import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import * as R from 'ramda';
import contriesList from 'iso-3166-1-alpha-2';
import { RegexFields } from '../../../../../constants/utils/regexFields';
import { BankDetails } from '../bankDetails';
import {GenericDetails} from './genericDetails';
import ServiceData from '../../../../../constants/models/serviceData';
import {ConnectionTypes} from '../../../../../constants/utils/connectionTypes';
import * as Loadings from '../../../../../constants/loadings/service';
import { useSelector } from 'react-redux';
import { PostalCityInput } from "../../../../../_common/postalCityInput";

export const CustomBranch = ({ customServiceData, boxIndex, setShowCustomBox, isMain, totalBranches, canCollapse, connectionType, title, removeBranch, generateRelocationLetters }) => {
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	const addressRef = useRef(null);
	const [collapsed, setCollapsed] = useState(false);
	const [wasSaved, setWasSaved] = useState(false);
	const services = useSelector((state) => state.services);
	const [customBranchDetails, setCustomBranchDetails] = useState(
		R.isNil(customServiceData)
			? {
					customServiceDetails: {
						name: "",
						address: {
							streetAddress: "",
							streetAddress2: "",
							postalCode: "",
							addressLocality: "",
							addressCountry: "FR",
						},
					},
					serviceId: undefined,
					id: "custom",
			  }
			: new ServiceData(customServiceData)
	);

	useEffect(() => {
		if (!isMain && !R.isNil(customServiceData)) {
			setCollapsed(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (boxIndex !== totalBranches - 1 && canCollapse === true) {
			setCollapsed(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [totalBranches]);

	let auxTitle = !R.isNil(customServiceData) && !R.isNil(customServiceData.customServiceDetails) ? customServiceData.customServiceDetails.name : undefined;

	useEffect(() => {
		if (!R.isNil(customServiceData) && (services.isLoading.includes(Loadings.ADD_NEW_SERVICE + customServiceData.id) || services.isLoading.includes(Loadings.UPDATING_SERVICE_DATA + customServiceData.id))) {
			setWasSaved(true);
		}
	}, [customServiceData, services.isLoading]);

	if (
		wasSaved &&
		collapsed === false &&
		!R.isNil(customServiceData) &&
		!services.isLoading.includes(Loadings.ADD_NEW_SERVICE + customServiceData.id) &&
		!services.isLoading.includes(Loadings.UPDATING_SERVICE_DATA + customServiceData.id) &&
		JSON.stringify(customServiceData) === JSON.stringify(services.serviceData[connectionType].find((b) => b.id === customServiceData.id))
	) {
		setWasSaved(false);
		setCollapsed(true);
	}

	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
	}, []);

	return (
		<section className={"card card-body" + (isMain ? "" : " mt-4")} id={title + boxIndex}>
			<div
				className="card-header p-0"
				id={"headingUserDetail" + title + boxIndex}
				role="button"
				onClick={() => {
					setTimeout(() => {
						setCollapsed(collapsed === true ? false : true);
					}, 200);
				}}>
				<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target={"#accordion " + title + " Donnes" + boxIndex} aria-expanded={collapsed === false} aria-controls={"accordion " + title + " Donnes"}>
					<h4 className="h3 font-weight-black container-tight my-auto">{isMain ? title + " Principale" : "Autre " + title}</h4>
					{!R.isNil(auxTitle) ? (
						<span className="mr-auto align-middle">
							<i className="eva eva-arrow-right mx-2 align-middle o-30"></i>
							<span className="o-60 align-middle">{auxTitle}</span>
						</span>
					) : (
						""
					)}
					<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-40" name="refPrincipal">
						<i className={"eva " + (collapsed === false ? "eva-arrow-ios-upward-outline" : "eva-arrow-ios-downward-outline")}></i>
					</button>
				</div>
			</div>
			<form className={"collapse" + (collapsed === false ? " show" : "")} ref={addressRef} id={"accordion " + title + " Donnes" + boxIndex} aria-labelledby={"headingUserDetail" + title + boxIndex} data-parent={"#" + title + boxIndex}>
				<div className="block mt-4">
					<div className="grid-sm grid-sm-1 grid-md-2 align-items-center mt-2 mb-sm">
						<h5 className="h4 text-uppercase text-secondary font-weight-black my-auto">Votre {title} *</h5>
					</div>
					<div className="row gx-2">
						<div className="col-12 col-md-5">
							<div className="form-group">
								<div className="flex-row gx-2 align-items-center mb-1">
									<label className="h6 font-weight-bolder my-auto" htmlFor={title + boxIndex}>
										Nom du service
									</label>
									<p
										className="form-text small text-gray my-auto ml-auto"
										data-toggle="tooltip"
										data-placement="top"
										data-html="true"
										data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
										title="Le nom de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
										<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
									</p>
								</div>
								<input
									required
									pattern=".*\S+.*"
									type="text"
									className="form-control rounded"
									id={title + boxIndex}
									placeholder="Nom du service"
									value={!R.isNil(customBranchDetails.customServiceDetails) ? customBranchDetails.customServiceDetails.name : ""}
									onChange={(e) => setCustomBranchDetails({ ...customBranchDetails, customServiceDetails: { ...customBranchDetails.customServiceDetails, name: e.target.value } })}
								/>
								<div className="invalid-feedback">
									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
									<span className="align-middle text-dark o-70">Ce champ est requis</span>
								</div>
							</div>
						</div>
						<div className="col-12 col-md-7">
							<div className="form-group">
								<div className="flex-row gx-2 align-items-center mb-1">
									<div className="flex-row gx-2 align-items-center mb-1">
										<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne1" + boxIndex}>
											Adresse ligne 1
										</label>
										<p
											className="form-text small text-gray my-auto ml-auto"
											data-toggle="tooltip"
											data-placement="top"
											data-html="true"
											data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
											title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
											<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
										</p>
									</div>
									<p
										className="form-text small text-gray my-auto ml-auto"
										data-toggle="tooltip"
										data-placement="top"
										data-html="true"
										data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
										title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
										<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
									</p>
								</div>
								<input
									type="text"
									pattern=".*\S+.*"
									className="form-control rounded"
									id={"Adresseligne1" + boxIndex}
									required
									placeholder="Adresse ligne 1"
									value={!R.isNil(customBranchDetails.customServiceDetails) ? customBranchDetails.customServiceDetails.address.streetAddress : ""}
									onChange={(e) => setCustomBranchDetails({ ...customBranchDetails, customServiceDetails: { ...customBranchDetails.customServiceDetails, address: { ...customBranchDetails.customServiceDetails.address, streetAddress: e.target.value } } })}
								/>
								<div className="invalid-feedback">
									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
									<span className="align-middle text-dark o-70">Ce champ est requis</span>
								</div>
							</div>
							<div className="form-group">
								<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne2" + boxIndex}>
									Adresse ligne 2
								</label>
								<input
									type="text"
									className="form-control rounded"
									id={"Adresseligne2" + boxIndex}
									placeholder="Adresse ligne 2"
									value={!R.isNil(customBranchDetails.customServiceDetails) ? customBranchDetails.customServiceDetails.address.streetAddress2 : ""}
									onChange={(e) => setCustomBranchDetails({ ...customBranchDetails, customServiceDetails: { ...customBranchDetails.customServiceDetails, address: { ...customBranchDetails.customServiceDetails.address, streetAddress2: e.target.value } } })}
								/>
							</div>
							<div className="row g-2">
								<PostalCityInput
									postalCode={!R.isNil(customBranchDetails.customServiceDetails) ? customBranchDetails.customServiceDetails.address.postalCode : ""}
									city={!R.isNil(customBranchDetails.customServiceDetails) ? customBranchDetails.customServiceDetails.address.addressLocality : ""}
									onChange={(updatedAddress) => setCustomBranchDetails({ ...customBranchDetails, customServiceDetails: { ...customBranchDetails.customServiceDetails, address: { ...customBranchDetails.customServiceDetails.address, postalCode: updatedAddress.postalCode, addressLocality: updatedAddress.city } } })}
									hasWrapper={false}
									country={!R.isNil(customBranchDetails.customServiceDetails) ? customBranchDetails.customServiceDetails.address.addressCountry : "FR"}
									customClasses={{ city: "form-group col-12 col-sm-6 col-lg", postalCode: "form-group col-12 col-sm-6 col-lg" }}
									postalCodePattern={!R.isNil(customBranchDetails.customServiceDetails) && customBranchDetails.customServiceDetails.address.addressCountry === "FR" ? RegexFields.frenchZipCode : undefined}
								/>

								<div className="form-group col-12 col-sm col-xl">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"Pays" + boxIndex}>
										Pays
									</label>
									<select
										className="custom-select"
										id={"Pays" + boxIndex}
										tabIndex={-98}
										defaultValue={!R.isNil(customBranchDetails.customServiceDetails) ? customBranchDetails.customServiceDetails.address.addressCountry : "FR"}
										onChange={(e) => setCustomBranchDetails({ ...customBranchDetails, customServiceDetails: { ...customBranchDetails.customServiceDetails, address: { ...customBranchDetails.customServiceDetails.address, country: e.target.value, addressCountry: e.target.value } } })}>
										{Object.keys(contriesList.getData()).map((country, idx) => (
											<option key={idx} value={country}>
												{countries.getName(country, "fr", { select: "official" })}
											</option>
										))}
									</select>
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					{connectionType === ConnectionTypes.bank ? (
						<BankDetails formRef={addressRef} isMain={false} branch={customBranchDetails} index={boxIndex} setShowCustomBox={setShowCustomBox} generateRelocationLetters={generateRelocationLetters} />
					) : (
						<GenericDetails connectionType={connectionType} customFormRef={addressRef} isMain={false} customServiceData={customBranchDetails} boxIndex={boxIndex} setShowCustomBox={setShowCustomBox} removeBranch={removeBranch} generateRelocationLetters={generateRelocationLetters} />
					)}
				</div>
			</form>
		</section>
	);
};